<div class="stepper-container">
  <mat-stepper class="stepper_upload_processing" (selectionChange)="onStepChange($event)" #stepper>
    <mat-step [ngClass]="{'completed-step': step1Completed}" label="{{'Catalogs.infos_rules' | translate}}" [formGroup]="form" class="static_steps">
      <div class="step_container">
        <div class="steps_block">
          <div class="step">
            <div class="step_title">
              <span>
                {{"Catalogs.catalog_informations"| translate}}
              </span>
            </div>
            <div class="content info_img">
              <div class="content_img" (change)="getCatalogImg($event)">
                <input class="file" type="file" id="upload" accept="image/jpeg, image/png, image/gif">
                <img class="icon_user"
                  [src]="imageCatalog ? 'data:;base64,' + imageCatalog : defaultVariantAvatar" for="upload"
                  alt="">
                  <ng-container *ngIf="imageCatalog">
                    <button *appHasPermission="{ module: 'catalog', action: 'create' }" class="cancel_upl" (click)="cancelImage()">
                      <mat-icon class="cancel_icon">cancel</mat-icon>
                    </button>
                  </ng-container>
              </div>
              <div class="fields_info">
                <div class="inline_block custom_block">
                  <div class="field">
                    <label for="">{{"common.name" | translate}}<span class="red">*</span></label>
                    <input type="text" formControlName="name" [placeholder]="'Catalogs.catalog_name'|translate">
                    <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">
                      {{"common.required_field" | translate}}
                    </span>
                  </div>
                  <div class="field">
                    <label for="">{{"common.status"|translate}}<span class="red">*</span></label>
                    <select name="" id="" formControlName="status">
                      <option selected value="" disabled>{{"common.status"|translate}}</option>
                      <option selected value="Draft">{{"common.draft"|translate}}</option>
                      <option selected value="Approved">{{"Catalogs.approved"|translate}}</option>
                      <option selected value="Inactive">{{"Catalogs.inactive"|translate}}</option>
                    </select>
                    <span class="error_ms" *ngIf="form.get('status')?.touched  && form.get('status')?.errors">
                      {{"common.required_field" | translate}}
                    </span>
                  </div>
                </div>
                <div class="inline_block no_padding">
                  <div class="field">
                    <label for="">
                    {{"common.start_date" | translate}}<span class="red">*</span>
                    </label>
                    <input type="date" formControlName="start_date">
                    <span class="error_ms" *ngIf="form.get('start_date')?.touched && !form.get('start_date')?.value && form.get('start_date')?.errors">
                      {{"common.required_field" | translate}}
                    </span>
                    <span class="error_ms" *ngIf="form.get('start_date')?.value && form.get('start_date')?.hasError('startDateInvalid')">
                    {{"Catalogs.start_date_must_be_today_or_later"|translate}}
                    </span>
                  </div>
                  <div class="field">
                    <label for="" class="slide_label">
                      <mat-slide-toggle [(ngModel)]="disableDate" (change)="onToggleChange()" [ngModelOptions]="{standalone: true}">
                      </mat-slide-toggle>
                      {{"common.end_date" | translate}}
                    </label>
                    <input type="date" formControlName="end_date">
                    <span class="error_ms" *ngIf="form.get('end_date')?.value && form.get('end_date')?.hasError('endDateInvalid')">{{"Catalogs.end_date_must"|translate}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="steps_block">
          <div [formGroup]="generalRulesform" class="step">
            <div class="step_title">
              <span>
                {{"Catalogs.general_rules" | translate}}<span class="red">*</span>
              </span>
            </div>
            <div class="content custom_content">
              <div class="rule_block">
                <div class="title_block">
                  <img src="assets/icones/overall-price.svg" alt="">
                  {{"Catalogs.overall_discount_adj"|translate }}
                </div>
                <div class="inline_block">
                  <div class="field inline_field">
                    <input type="number" formControlName="general_discount" (input)="onGeneralDiscountChange($event)">
                    <span class="indicate_input custom_indic">%</span>
                    <span class="error_ms" *ngIf="generalRulesform.get('general_discount')?.touched && generalRulesform.get('general_discount')?.errors">
                      {{"common.required_field" | translate}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button class="save_btn_pop_up cancel_btn_pop_up" (click)="canceled()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
          </button>
          <button class="save_btn_pop_up blue_btn" *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="next('basic_infos')">
              <span>{{"common.next" | translate | uppercase}}</span>
              <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
          </button>
        </div>
      </div>
    </mat-step>
    <mat-step [ngClass]="{'completed-step': step2Completed}" label="{{'quotations_and_orders.product' | translate}}" class="static_steps">
      <app-inserting-products
        *ngIf="stepper.selectedIndex===1"
        [selectedProducts0]="selectedProducts"
        [submitType]="'stepper'"
        (cancelProducts)="cancel($event)"
        (saveProducts)="onSaveProducts($event)">
      </app-inserting-products>
    </mat-step>
    <mat-step [ngClass]="{'completed-step': step3Completed}" label="{{'Catalogs.overrides' | translate}}" class="static_steps">
      <app-custom-catalog-products
        *ngIf="stepper.selectedIndex===2"
        [submitType]="'stepper'"
        [selectedProducts0]="selectedProducts"
        [generalRules0]="generalRules"
        (saveCustomProducts)="onSaveCustomProducts($event)"
        (saveGeneraleRule)="saveGeneraleRule($event)"
        (cancelCustom)="cancel($event)"
        >
      </app-custom-catalog-products>
    </mat-step>
    <mat-step [ngClass]="{'completed-step': step4Completed}"  label="{{'common.location' | translate}}" class="static_steps">
      <app-inserting-locations
        *ngIf="stepper.selectedIndex===3"
        [submitType]="'stepper'"
        [selectedLocationsO]="selectedLocations"
        [currentCustomDiscount]="currentCustomDiscount"
        (cancelLocations)="cancel($event)"
        (saveLocations)="onSaveLocations($event)">
      </app-inserting-locations>
    </mat-step>
    <mat-step [ngClass]="{'completed-step': step5Completed}" label="{{'common.summary' | translate}}" class="static_steps">
      <form [formGroup]="form" class="step_container" *ngIf="currentSummary==='summary'">
        <div class="static_steps">
          <div class="left_part side_part">
            <div class="step">
              <div class="step_title">
                <span>
                  {{"Catalogs.catalog_informations"|translate}}
                </span>
                <button class="add_btn" *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="editBasicInfo()">
                  <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                  <span>{{"common.edit"|translate}}</span>
                </button>
              </div>
              <div class="content info_img">
                <div class="content_img" (change)="getCatalogImg($event)">
                  <img class="icon_user"
                    [src]="imageCatalog ? 'data:;base64,' + imageCatalog : defaultVariantAvatar"
                    alt="">
                </div>
                <div class="fields_info">
                  <div class="field field_info">
                    <label for=""> {{"common.name"|translate}}</label>
                    <span class="summary_field">{{this.form.get('name')?.value}}</span>
                  </div>
                  <div class="field field_info">
                    <label for="">{{"common.status"|translate }}</label>
                    <span class="summary_field">{{this.form.get('status')?.value.toUpperCase()}}</span>
                  </div>
                  <div class="inline_block no_padding">
                    <div class="field field_info">
                      <label for="">
                        {{"common.start_date"|translate}}
                      </label>
                      <span class="summary_field">{{this.form.get('start_date')?.value}}</span>
                    </div>
                    <div class="field field_info">
                      <label for="">
                      {{"common.end_date"|translate}}
                      </label>
                      <span class="summary_field">{{this.form.get('end_date')?.value}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="step first_step">
              <div class="step_title">
                <span>
                  {{"Catalogs.companies_locations" |translate}} ({{selectedLocations.length}})
                </span>
                <button class="add_btn" *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="goTo('insertLocations')">
                  <img src="assets/icones/add_icon.svg" alt="">
                  <span>{{"common.insert" | translate}}</span>
                </button>
              </div>
              <div class="content">
                <div *ngIf="!selectedLocations || selectedLocations.length === 0">
                  {{"Catalogs.no_locations_available"|translate}}
                </div>
                <table class="listing_table" *ngIf="selectedLocations.length > 0">
                  <thead class="">
                    <tr class="head_table">
                      <th>{{"Catalogs.company_location" | translate}}</th>
                      <th>{{"Catalogs.custom_discount" | translate}}</th>
                      <th>{{"Catalogs.total_discount" | translate}}</th>
                      <th>{{"Catalogs.currency" | translate}}</th>
                      <th>{{"common.del" | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let location of selectedLocations let i = index">
                      <tr class="body_table">
                        <td class="td_block">
                          <span class="bold_span">{{ location.company_name + ' - ' + location.name }}</span><br>
                          <span class="light_span">{{location.apartment}}</span>
                        </td>
                        <td class="td_block">
                          <span class="bold_span">{{ location.custom_discount ? "-"+location.custom_discount+"%" : 'N/A' }}</span>
                        </td>
                        <td>
                          {{sumDiscount(location.custom_discount) ? "-" +sumDiscount(location.custom_discount)+"%" : 'N/A' }}
                        </td>
                        <td>
                          <span class="descr_elemnt">
                            {{location.currency?.name}}
                            </span>
                        </td>
                        <td>
                          <button *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="removeLocation(location)">
                            <img src="assets/icones/black-removed.svg" alt="">
                          </button>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="right_part side_part">
          <div [formGroup]="generalRulesform" class="step">
            <div class="step_title">
              <span>
                  {{"Catalogs.general_rules"| translate}}
              </span>
              <button class="add_btn" *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="editGeneralRules()">
                <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                <span>{{"common.edit"| translate}}</span>
              </button>
            </div>
            <div class="content customers_chip">
              <mat-tab-group>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      <img src="assets/icones/overall-price.svg" alt="">
                      {{"Catalogs.overall_discount_adj"|translate }}
                    </div>
                  </ng-template>
                  <div class="inline_block">
                    <div class="field category_field">
                      <input type="number" formControlName="general_discount" readonly (input)="onGeneralDiscountChange($event)">
                      <span class="indicate_input custom_indic">%</span>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      <img src="assets/icones/overall-quantity.svg" alt="">
                    {{"Catalogs.overall_quantity_adj"|translate}}
                    </div>
                  </ng-template>
                  <div class="inline_block mat_tab_block">
                    <div class="field">
                      <input type="number" formControlName="increment" readonly (input)="onGeneralIncrementChange($event)">
                      <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                    </div>
                    <div class="field">
                      <input type="number" formControlName="min_qte" readonly (change)="onGeneralMinChange($event)">
                      <span class="indicate_input custom_indic">{{"Catalogs.min"|translate}}</span>
                    </div>
                    <div class="field">
                      <input type="number" formControlName="max_qte" readonly (change)="onGeneralMaxChange($event)">
                      <span class="indicate_input custom_indic">{{"Catalogs.max"|translate}}</span>
                    </div>
                  </div>
                  <div class="inline_block">
                    <div class="field">
                      <label for="">{{ "Catalogs.can_be_sold_out_of_stock" | translate }}</label>
                      <mat-slide-toggle [checked]="generalRulesform.get('can_be_sold_out_of_stock')?.value" disabled>
                      </mat-slide-toggle>
                    </div>
                    <div class="field">
                      <label for="">{{ "Catalogs.show_stock" | translate }}</label>
                      <mat-slide-toggle [checked]="generalRulesform.get('show_stock')?.value" disabled>
                      </mat-slide-toggle>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab disabled>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      <img src="assets/icones/volume.svg" alt="">
                      {{"Catalogs.overall_volume_adj"|translate}}
                    </div>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
            <div class="step">
              <div class="step_title">
                <span class="curser" (click)="goTo('customProducts')">
                  {{"Catalogs.product" | translate}}({{getLengthProductsPlusVariants()}})
                </span>
                <button class="add_btn" *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="goTo('insertProducts')">
                  <img src="assets/icones/add_icon.svg" alt="">
                  <span>{{"common.insert"| translate}}</span>
                </button>
              </div>
              <div class="total_title" (click)="goTo('customProducts')">
                <span class="total">{{getLengthProductsPlusVariants()}}</span>
                <div class="action_btn btn_edit">
                  <span class="included">{{"Catalogs.products_included" | translate}}</span>
                  <img src="../../../../../assets/icones/blue_eye.svg" alt="">
                </div>
              </div>
              <div class="content customers_chip">
                <div class="field">
                  <label for="" class="label_list">
                    <img src="assets/icones/brand.svg" alt="">
                    <span>{{"brands.brands"| translate}} ({{getUniqueBrands().length}})</span>
                  </label>
                  <div class="inline_block">
                    <span class="item_tag" *ngFor="let brand of getUniqueBrands()">{{brand.name}}</span>
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label_list">
                    <img src="assets/icones/categories.svg" alt="">
                    <span>{{"Categories.categories" | translate}} ({{getUniqueCategories().length}})</span>
                  </label>
                  <div class="inline_block">
                    <span class="item_tag" *ngFor="let category of getUniqueCategories()">{{category.name}}</span>
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label_list">
                    <img src="assets/icones/tags.svg" alt="">
                    <span>
                      {{"Labels.labels" | translate}} ({{getUniqueTags().length}})
                    </span>
                  </label>
                  <div class="inline_block">
                      <span class="item_tag" *ngFor="let tag of getUniqueTags()">{{tag.name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span>{{"common.back"| translate}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
          </button>
          <button class="save_btn_pop_up green_btn" *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="save()">
            <span>{{"common.save" | translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
        </div>
      </form>
      <app-inserting-products
        *ngIf="currentSummary==='insertProducts'"
        [selectedProducts0]="selectedProducts"
        (cancelProducts)="cancel($event)"
        (saveProducts)="onSaveProducts($event)"
      >
      </app-inserting-products>
      <app-inserting-locations
        *ngIf="currentSummary==='insertLocations'"
        [selectedLocationsO]="selectedLocations"
        [currentCustomDiscount]="currentCustomDiscount"
        (cancelLocations)="cancel($event)"
        (saveLocations)="onSaveLocations($event)">
      </app-inserting-locations>
      <app-custom-catalog-products
        *ngIf="currentSummary==='customProducts'"
        [selectedProducts0]="selectedProducts"
        [generalRules0]="generalRules"
        (saveCustomProducts)="onSaveCustomProducts($event)"
        (saveGeneraleRule)="saveGeneraleRule($event)"
        (cancelCustom)="cancel($event)"
        >
      </app-custom-catalog-products>
    </mat-step>
  </mat-stepper>
</div>
